// extracted by mini-css-extract-plugin
export default {"account_form_tests_wrapper":"AccountForm_account_form_tests_wrapper__Wr-j3"};